import {Injectable} from '@angular/core';
import {PaymentModeService} from './state/service';
import {PaymentModeQuery} from './state/query';
import {FilterService as BaseService} from '../../components/filter.service';
import {PaymentMode} from './state/model';
import {PaymentModeState, Store} from './state/store';


@Injectable({providedIn: 'root'})
export class FilterService extends BaseService<PaymentMode, PaymentModeState, PaymentModeQuery, Store> {
  constructor(protected query: PaymentModeQuery, protected api: PaymentModeService) {
    super(query, api);
  }
}
